const map = {
	"./2024/Registration/events.json": 19002,
	"./2025/Registration/events.json": 48641,
	"./2026/Registration/events.json": 92180
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	const id = map[req];
	return __webpack_require__.t(id, 1 | 16);
});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 81364;
module.exports = webpackAsyncContext;